import { render, staticRenderFns } from "./shipping-method.vue?vue&type=template&id=04f7c49c&"
import script from "./shipping-method.vue?vue&type=script&lang=js&"
export * from "./shipping-method.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports